package nacholab.supplies.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.clip
import nacholab.supplies.ui.theme.SuppliesTheme
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.TextInput

@Composable
fun NLTextInput(value: String, onChange: (String) -> Unit, modifier: Modifier = Modifier, placeholder: String? = null){
    TextInput(
        value = value,
        attrs = modifier
            .height(48.px)
            .background(SuppliesTheme.colors.utilityField)
            .padding(leftRight = 24.px)
            .clip(Rect(cornerRadius = 24.px))
            .fontSize(24.px)
            .color(SuppliesTheme.colors.secondary)
            .toAttrs {
                placeholder?.let { placeholder(it) }
                onInput { onChange(it.value) }
            }
    )
}

@Composable
fun NLNumberInput(value: Int, onChange: (Int) -> Unit, modifier: Modifier = Modifier){
    TextInput(
        value = value.toString(),
        attrs = modifier
            .height(48.px)
            .background(SuppliesTheme.colors.utilityField)
            .padding(leftRight = 24.px)
            .clip(Rect(cornerRadius = 24.px))
            .fontSize(24.px)
            .color(SuppliesTheme.colors.secondary)
            .toAttrs {
                onInput { onChange(it.value.toInt()) }
            }
    )
}